import { BREAKPOINTS } from './tokens';

export type ScreenSize = 'mobile' | 'tablet' | 'desktop';

export const screenSizeFor = (width: number): ScreenSize => {
  if (width >= BREAKPOINTS.desktop) return 'desktop';
  if (width >= BREAKPOINTS.tablet) return 'tablet';
  return 'mobile';
};
